
        import * as module0 from './controllers/email_subscription_controller.js';import * as module1 from './controllers/random_post_controller.js'
        const modules = {
            "./controllers/email_subscription_controller.js": module0,
            "./controllers/random_post_controller.js": module1,
        };
        export default modules;
      